import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/PromoCode.scss';
import getRelayEnvironment from '../../../global/relayModernEnvironment';

import DisplayPromoCode from 'dibs-display-promo-code';

class PromoCode extends PureComponent {
    render() {
        const { userId, itemId, showNetPrice, showSalePrice } = this.props;

        return (
            <div className={styles.container}>
                <DisplayPromoCode
                    userId={userId}
                    itemId={itemId}
                    isFurtherReduced={showNetPrice || showSalePrice}
                    environment={getRelayEnvironment()}
                />
            </div>
        );
    }
}

PromoCode.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string,
    showNetPrice: PropTypes.bool.isRequired,
    showSalePrice: PropTypes.bool.isRequired,
};

PromoCode.defaultProps = {
    pricingDisplayInfo: {},
};

export default PromoCode;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/PromoCode.jsx